export class DocumentDetailsModel{
    public NationalIdTypeLkp:any;
    public NationalIdentifierValue:string;
    public NationalIdIssueDate:string;
    public NationalIdExpiryDate:string;
    public PlaceOfIssue:string;
    constructor(){
        
    }
}